export default {"src":"/_next/static/media/looking-ahead-lg.colour.1843ee2f.svg","height":263,"width":508,"blurWidth":0,"blurHeight":0};